module.exports = __webpack_public_path__ + "static/4-FUTURE-WORKPLACE-DESIGN-38411b3016bbbdd065fd1d81edbe3184.png";